import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

const PANEL_ID = 'poster-editor-tabs-text-panel';

export default function PosterEditorTabsTextModal(): ReactElement<any> {
  const height = '208px';
  const maxWidth = '900px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_TABS_TEXT_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="poster-editor-tabs-text-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorTabsTextModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_TABS_TEXT_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
